module.exports = __webpack_public_path__ + "static/UI-screenshot2-7c3203fe532836c1ca39d955690840f4.png";